exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".plannerNudgeContainer-4f898f5c>div{margin:10px 15px !important}.plannerNudge-0d6c316a{display:flex;flex-wrap:nowrap;justify-content:space-between;align-items:center;user-select:none}.plannerNudge-0d6c316a .centered-e7c43cfa>span{margin-right:20px}.plannerNudge-0d6c316a a{margin-right:10px}.plannerNudge-0d6c316a a:last-child{margin-right:0px}\n", ""]);

// Exports
exports.locals = {
	"plannerNudgeContainer": "plannerNudgeContainer-4f898f5c",
	"plannerNudge": "plannerNudge-0d6c316a",
	"centered": "centered-e7c43cfa"
};